// import PropTypes from 'prop-types'; -> NO PROP-TYPES, this is only a WRAPPER for MATCH-CHANGE-LMP and MATCH-CHANGE-HP
import React from 'react';

import { IMatchChangeHp, MatchChangeHp } from './match-change-hp';
import { IMatchChangeLmp, MatchChangeLmp } from './match-change-lmp';

import './match-change.scss';

// EXPORT all INTERFACES of managed COMPONENTS
export { IMatchChangeHp } from './match-change-hp';
export { IMatchChangeLmp } from './match-change-lmp';

const MatchChange = (props: IMatchChangeLmp | IMatchChangeHp) =>
  props.variant === 'lmp' ? (
    <MatchChangeLmp {...(props as IMatchChangeLmp)} />
  ) : (
    <MatchChangeHp {...(props as IMatchChangeHp)} />
  );

export default MatchChange;
